module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "successHolder"
  }, [_c('div', {
    staticClass: "drpAllImgSvg successImg"
  }), _vm._v(" "), _c('div', {
    staticClass: "submittedTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.front_page.decline_msg")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b240020c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Admin/Decline.vue
// module id = 165
// module chunks = 1